/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import { useState, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Search } from 'react-bootstrap-icons'
import { PublishContext } from '../publish-context/PublishContext'

interface PatientSearchProps {
  search: (textData: string) => void
}

const PatientSearch: React.FC<PatientSearchProps> = ({ search }) => {
  const publishContext = useContext(PublishContext)
  const { t: translate } = useTranslation()
  const [searchQuery, setSearchQuery] = useState<string>('')

  useEffect(() => {
    setSearchQuery(publishContext?.selectionsData?.searchString ?? '')
  }, [])

  const isSiteSelected = !!publishContext?.selectionsData?.siteFolderIds?.length

  return (
    <div className="search-container">
      <div className="pdr-publish-level search-wrapper">
        <input
          id="0fb8e1c3-381a-4951-b42c-ef847f8ad31a"
          type="text"
          autoComplete="off"
          className="search-input"
          placeholder={translate('SEARCH_PATIENT')}
          value={searchQuery}
          onChange={(evt) => {
            setSearchQuery(evt.target.value)
          }}
          onKeyDown={(evt) => {
            if (evt.key === 'Enter') {
              search(searchQuery)
            }
          }}
          maxLength={255}
          disabled={!isSiteSelected}
        />
        <button
          id="be612188-bad5-4e1a-b854-607fd692220f"
          onClick={() => {
            search(searchQuery)
          }}
          className="search-filter-btn"
          type="button"
        >
          <Search className="w100p h100p" />
        </button>
      </div>
    </div>
  )
}

export default PatientSearch
